import React, { createContext, useState, useEffect } from "react";

export const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState(() => {
    try {
      const savedFavorites = localStorage.getItem("favorites");
      return savedFavorites ? JSON.parse(savedFavorites) : [];
    } catch (error) {
      console.error("Failed to parse favorites from localStorage", error);
      return [];
    }
  });

  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem("isLoggedIn") === "true";
  });

  useEffect(() => {
    try {
      localStorage.setItem("favorites", JSON.stringify(favorites));
    } catch (error) {
      console.error("Failed to save favorites to localStorage", error);
    }
  }, [favorites]);

  useEffect(() => {
    localStorage.setItem("isLoggedIn", isLoggedIn.toString());
  }, [isLoggedIn]);

  const addToFavorites = (productId) => {
    if (!isLoggedIn) {
      return { success: false, message: "Please log in first" };
    }
    if (!favorites.includes(productId)) {
      setFavorites([...favorites, productId]);
    }
    return { success: true, message: "Added to favorites" };
  };

  const removeFromFavorites = (productId) => {
    setFavorites(favorites.filter((id) => id !== productId));
    return { success: true, message: "Removed from favorites" };
  };

  const toggleFavorite = (productId) => {
    if (!isLoggedIn) {
      return { success: false, message: "Please log in first" };
    }
    if (favorites.includes(productId)) {
      return removeFromFavorites(productId);
    } else {
      setFavorites([...favorites, productId]);
      return { success: true, message: "Added to favorites" };
    }
  };

  const isFavorite = (productId) => {
    return favorites.includes(productId);
  };

  const login = () => {
    setIsLoggedIn(true);
  };

  const logout = () => {
    setIsLoggedIn(false);
    setFavorites([]);
  };

  return (
    <FavoritesContext.Provider
      value={{
        favorites,
        isLoggedIn,
        addToFavorites,
        removeFromFavorites,
        toggleFavorite,
        isFavorite,
        login,
        logout,
      }}
    >
      {children}
    </FavoritesContext.Provider>
  );
};
